<template>
    <section class="inNewsListBox">
        <div class="wrapper">

            <template  v-if="newsListArr && newsListArr.length>0">  
                <section class="inNewsListItem" v-for="item in newsListArr" :key="item.id">
                    <router-link :to="item.link">
                        <div class="date  wow slideInUp" data-wow-duration="1s" data-wow-delay="100ms">
                            <div class="day">{{item.date.day}}</div>
                            <div class="month">{{item.date.month}}</div>
                        </div>
                        <div class="word">
                            <div class="title  wow slideInUp" data-wow-duration="1s">
                                {{item.title}}
                            </div>
                            <div class="eyes  wow slideInUp" data-wow-duration="1s">
                                <i class="fa fa-eye"></i> <span>{{item.visits}}</span> 
                            </div>
                            <div class="desc  wow slideInUp" data-wow-duration="1s">
                                {{item.desc}}
                            </div>
                        </div>
                        <div class="img  wow slideInUp" data-wow-duration="1s">
                            <img v-if="item.imgUrl" :src="$root.$TEMP_URL+item.imgUrl" />
                            <img v-else src="./images/noimg.jpg" />

                        </div>
                    </router-link>
                </section>
            </template>
             <template v-else>
                <div class="inProNoData">
                    {{isZhong?'暂无数据':'No Data'}}
                </div>
          </template>


          <div class="newPageBox">
               <div class="newsPrePage" @click="handlePre()"><</div>
               <div class="newsPageItem" :class="{ active: (item===curPage) }" @click="handleNewsItem(item)" v-for="(item,index) in pageList" :key="index" v-html="item"></div>
               <div class="newsNextPage" @click="handleNext()">></div>
          </div>


        </div>
    </section>
</template>

<script>
import { getListPage} from '../../../api'

export default {
    
    data() {
        return {
            isZhong:false,
            total:0,
            pageList:[],
            curPage:1,
            newsListArr:[
                {
                    id:'001',
                    date:{
                        day:26,
                        month:2021.06
                    },
                    title:'The company successfully passed...',
                    visits:2568,
                    desc:'testtesttesttesttesttesttesttestt',
                    imgUrl:'./static/images/news_01.jpg',
                    link:'#'
                },
                {
                    id:'002',
                    date:{
                        day:22,
                        month:2021.05
                    },
                    title:'The title...',
                    visits:68,
                    desc:'description',
                    imgUrl:'./static/images/news_01.jpg',
                    link:'#'
                },
                {
                    id:'003',
                    date:{
                        day:16,
                        month:2021.04
                    },
                    title:'The company successfully passed...',
                    visits:68,
                    desc:'testtesttesttesttesttesttesttestt',
                    imgUrl:'./static/images/news_01.jpg',
                    link:'#'
                },
            ]
        };
    },
    created(){
        
       this.upDateNewsArr()

    },
    methods:{
        handleNewsItem(item){
            console.log(item)
            let curPage = item;
            this.curPage =curPage;
            this.upDateNewsArr();

        },
        handlePre(){
            let curPage = this.curPage;
            if(curPage<=1){
                return;
            }
            curPage = curPage-1;
            this.curPage =curPage;
            this.upDateNewsArr();
        },
        handleNext(){
            let curPage = this.curPage;
            let pageList = this.pageList;

            if(curPage>=pageList.length){
                return;
            }
            curPage = curPage+1;
            this.curPage =curPage;
            this.upDateNewsArr();
        },

        async upDateNewsArr(){
            const isZhong = this.$parent.isZhong;
            this.isZhong = isZhong; 

            let res2;
            let total = 0; //新闻总数量
            let pageList =[1];
            let curPage = this.curPage;
            if(isZhong){
                res2 = await getListPage(47,6,curPage);
            
            }else{
                res2 = await getListPage(2,6,curPage);
            
            }

            total = res2.rowtotal;
            let pageAllNum = Math.ceil(total / 6);
            for(var i=1;i<pageAllNum;i++){
                pageList.push(i+1)
            }
            this.pageList = pageList;

        //更新新闻列表
            let newsListArr = res2.data;
            newsListArr = newsListArr.map(v=>{
                return{
                    id:v.id,
                    date:{
                        day:v.date.slice(8,10),
                        month:v.date.slice(0,7)
                    },
                    title:v.title,
                    visits:v.visits,
                    desc:v.description,
                    imgUrl:v.ico,
                    link:'/news/newsdetail/'+v.id
                }
            })
            this.newsListArr = newsListArr;
        }
    }
   
};
</script>

<style lang="scss" scoped>
@import '../../../common/css/mixin.scss';
.inNewsListBox {
   background: #fafdfd;  
   padding: 82px 0;
}
.inNewsListItem {
   a{
        padding: 28px 28px 28px 28px;
        display: block;
        @include flexFather;
        align-items: flex-start;
        .date {
            margin-right: 56px;
            width: 106px;
            height: 106px;
            background: #0d69af;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            position: relative;
            margin-top: 32px;
            .day {
                color: #fff;
                font-size: 36px;
                font-weight: bold;
                text-align: center;
                margin-bottom: 6px;
            }
            .month {
                color: #fff;
                font-size: 12px;
                text-align: center;
            }
            &::after{
                content: '';
                position: absolute;
                height: 96px;
                bottom: 0;
                right: -30px;
                width: 1px;
                background: #e9ecec;
            }
        }
        .word {
            flex: 1;
            margin-top: 32px;
            .title {
                line-height: 28px;
                font-size: 16px;
                height: 28px;
                overflow: hidden;
            }
            .eyes {
            margin: 8px 0 ;
            color: #ccc;
            }
            .desc {
                line-height: 28px;
                overflow: hidden;
                height: 56px;
            }
        }
        .img{
            width: 258px;
            overflow: hidden;
            margin-left: 16px;
            img{
                width: 100%;
                height: 192px;
                @include compatible(transition,all 1s);
            }
            &:hover{
                img{
                  @include compatible(transform,scale(1.1));
                }
            }
        }
        &:hover{
            background: #f7f7f7;
            .date {
                background: #e60111;
                
               
            }
        }
   }
  
}
.inProNoData{
    min-height: 298px;
    background: #fbfbfb;
    display: flex;
    justify-content: center;
    align-items: center;
}

.newPageBox {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
    >div{
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        background: #eaeaea;
        margin-left: 6px;
        cursor: pointer;
    }
  .newsPrePage {


  }

  .newsPageItem {
      &.active{
          background: #0e68ad;
          color: #fff;
      }
  }

  .newsNextPage {

  }
}
</style>


// WEBPACK FOOTER //
// src/pages/News/NewsList/NewsList.vue